import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { SuggestedQuestion } from './types';
import { SidebarSection, SidebarHeader, SuggestedItems, SuggestedItem } from './styles';

interface SuggestedQuestionsProps {
  isOpen: boolean;
  isDarkMode: boolean;
  onQuestionClick: (question: string) => void;
}

const questions: SuggestedQuestion[] = [
  { key: 'about', translationKey: 'widget.suggested.about' },
  { key: 'dataSystems', translationKey: 'widget.suggested.dataSystems' },
  { key: 'aws', translationKey: 'widget.suggested.aws' },
  { key: 'leadership', translationKey: 'widget.suggested.leadership' },
  { key: 'projects', translationKey: 'widget.suggested.projects' },
];

const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = ({
  isOpen,
  isDarkMode,
  onQuestionClick,
}) => {
  const { t } = useLanguage();

  return (
    <SidebarSection isOpen={isOpen}>
      <details open>
        <SidebarHeader isDarkMode={isDarkMode}>
          {t('widget.suggestedHeader')}
        </SidebarHeader>
        <SuggestedItems>
          {questions.map((q) => (
            <SuggestedItem
              key={q.key}
              onClick={() => onQuestionClick(t(q.translationKey))}
              isDarkMode={isDarkMode}
            >
              {t(q.translationKey)}
            </SuggestedItem>
          ))}
        </SuggestedItems>
      </details>
    </SidebarSection>
  );
};

export default SuggestedQuestions;
